export const hasVisibleChartValue = (
  data: Array<Record<string, string | number | null>> | null,
  key: string,
): boolean =>
  Boolean(
    data?.some((row) => {
      const value = row[key];
      return typeof value === 'number' && Number.isFinite(value) && value > 0;
    }),
  );

export const hasVisibleStackedChartValue = (
  data: Array<Record<string, string | number>>,
  series: Array<{ key: string }>,
): boolean =>
  data.some((row) =>
    series.some((seriesItem) => {
      const value = row[seriesItem.key];
      return typeof value === 'number' && Number.isFinite(value) && value > 0;
    }),
  );

export const SKELETON_DEBUG_CHART_HEIGHT = 320;
